export { Input } from "./component";
export type {
  InputProps,
  InputSize,
  InputStyleProps,
  InputVariant,
} from "./types";
